import React, { useEffect } from "react"
import { ActionItem, ActionItemTitle } from "./styled"
import { AIScanIcon, LockedIcon } from "./Icons"
import {
  useCheckShouldShowTutorial,
  useIsTutorialShowed,
  useTutorialBackPath,
} from "features/onboarding/hooks"
import { useLogBrazeEvent } from "libs/braze"
import { useNavigate } from "react-router-dom"
import PATHS from "router/paths"
import PaywallTriggerWrapper from "features/home/Paywall/WebViewPaywallTrigerer"
import { FlexBox } from "components/Common/FlexBox"

interface AIScanSectionProps {
  hasAIScanEntitlement: boolean
  getUserPlanLoading: boolean
}

const AIScanAction = ({
  hasAIScanEntitlement,
  getUserPlanLoading,
}: AIScanSectionProps) => {
  const { updateIsTutorialShowed } = useIsTutorialShowed()

  useEffect(() => {
    updateIsTutorialShowed(false)
  }, [])

  const { isShowTutorial, checkShowTutorialLoading } =
    useCheckShouldShowTutorial()

  const { updateTutorialBackPath } = useTutorialBackPath()
  const { logBrazeTryAIStarted } = useLogBrazeEvent()

  const navigate = useNavigate()

  const onTryAI = () => {
    if (checkShowTutorialLoading || getUserPlanLoading) return

    if (!hasAIScanEntitlement) {
      return
    }

    logBrazeTryAIStarted()

    if (isShowTutorial) {
      updateTutorialBackPath(`${location.pathname}${location.search}`)
      navigate(`${PATHS.app.meal.tutorial}`)
    } else {
      navigate(`${PATHS.app.meal.scan}`)
    }
  }

  return (
    <PaywallTriggerWrapper isCheckingAIScan>
      <ActionItem onClick={onTryAI}>
        <AIScanIcon />
        <FlexBox $alignItems="center" $justify="center" $gap={4}>
          {!hasAIScanEntitlement && <LockedIcon />}
          <ActionItemTitle>AI Scanner</ActionItemTitle>
        </FlexBox>
      </ActionItem>
    </PaywallTriggerWrapper>
  )
}

export default AIScanAction
